import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';

var TransitionReturnPage = function (_super) {
  __extends(TransitionReturnPage, _super);

  function TransitionReturnPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ReturnStatusList = [];
    _this.dataList = [];
    _this.columns = [];
    _this.rowSelection = {};
    _this.warehouseList = [];
    _this.selectedList = [];
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition();
    _this.loadingStatus = false;
    _this.searchData = _this.getInitSearchData();
    _this.lastParams = {};
    _this.total = 0;
    _this.transitionReturnListCodeTypeEnum = [];
    _this.transitionReturnListTimeTypeEnum = [];
    return _this;
  }

  TransitionReturnPage.prototype.updateSearchList = function () {
    this.queryTransitionReturnList();
  };

  TransitionReturnPage.prototype.onDatetimeDefaultValueChange = function (arr) {
    if (arr.length) {
      this.searchData.begin_time = this.$util.formatDateTime(arr[0]);
      this.searchData.end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.begin_time = '';
      this.searchData.end_time = '';
    }
  };

  TransitionReturnPage.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('退货单号'),
      scopedSlots: {
        customRender: 'returnCode'
      }
    }, {
      title: this.t('货运单号'),
      scopedSlots: {
        customRender: 'receiving_code'
      }
    }, {
      title: this.t('发货参考号'),
      dataIndex: 'refer_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('目的仓'),
      dataIndex: 'warehouse',
      scopedSlots: {
        customRender: 'warehouse'
      }
    }, {
      title: this.t('退货数量'),
      align: 'right',
      dataIndex: 'return_quantity',
      scopedSlots: {
        customRender: 'return_quantity'
      }
    }, {
      title: this.t('状态'),
      dataIndex: 'return_status_text',
      filterEmpty: true,
      scopedSlots: {
        customRender: 'return_status_text'
      }
    }, {
      title: this.t('备注'),
      dataIndex: 'remark',
      width: 250,
      scopedSlots: {
        customRender: 'remark'
      }
    }, {
      title: this.t('时间'),
      dataIndex: 'time',
      scopedSlots: {
        customRender: 'time'
      }
    }];
    this.rowSelection = {
      onChange: function onChange(selectedRowKeys) {
        _this.selectedList = selectedRowKeys;
      }
    };
    this.queryTransitionReturnList();
    this.queryWarehouseList();
  };

  TransitionReturnPage.prototype.queryTransitionReturnList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            this.total = null;
            return [4, this.$api.intlCargo.queryTransitionReturnList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total;
            this.selectedList = [];
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  TransitionReturnPage.prototype.queryWarehouseList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.common.queryAllWarehouseList()];

          case 1:
            _a = _b.sent().data, data = _a === void 0 ? [] : _a;
            this.warehouseList = data;
            return [2];
        }
      });
    });
  };

  TransitionReturnPage.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      return_status: undefined,
      code_type: 'return_code',
      code_value: '',
      warehouse_code: undefined,
      time_type: 'update_time',
      begin_time: '',
      end_time: ''
    };
  };

  TransitionReturnPage.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.queryTransitionReturnList();
  };

  TransitionReturnPage.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryTransitionReturnList();
  };

  TransitionReturnPage.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  TransitionReturnPage.prototype.handleSearch = function () {
    this.initPage();
    this.queryTransitionReturnList();
  };

  TransitionReturnPage.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition();
    this.$nextTick(function () {
      return _this.queryTransitionReturnList();
    });
  };

  TransitionReturnPage.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};

            if (isAll) {
              postData = __assign({}, this.lastParams);
              delete postData.page_index;
              delete postData.page_size;
              postData["export"] = 1;
              postData.return_codes = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData["export"] = 2;
              postData.return_codes = this.selectedList;
            }

            return [4, this.$api.intlCargo.exportTransitionReturn(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([enumData('IntlCargo/TransitionReturnStatusStatusEnum')], TransitionReturnPage.prototype, "ReturnStatusList", void 0);

  __decorate([enumData('IntlCargo/TransitionReturnListCodeTypeEnum')], TransitionReturnPage.prototype, "transitionReturnListCodeTypeEnum", void 0);

  __decorate([enumData('IntlCargo/TransitionReturnListTimeTypeEnum')], TransitionReturnPage.prototype, "transitionReturnListTimeTypeEnum", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], TransitionReturnPage.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([loading('loadingStatus')], TransitionReturnPage.prototype, "queryTransitionReturnList", null);

  __decorate([userPrefPageSize('transitionReturnList')], TransitionReturnPage.prototype, "getInitSearchData", null);

  TransitionReturnPage = __decorate([Component], TransitionReturnPage);
  return TransitionReturnPage;
}(Vue);

export default TransitionReturnPage;